<template src="./SettingFormatFileComponent.html"></template>
<script>
import IconHome from "@/components/icons/IconHome.vue";
import BreadcrumbComponent from "@/components/breadcrumb/BreadcrumbComponent.vue";
import InputTextNormal from "@/components/inputs/input-text/normal/InputTextNormal.vue";
import SelectNormal from "@/components/inputs/select/normal/SelectNormal.vue";
import ButtonSearchComponent from "@/components/buttons/button-search/ButtonSearchComponent.vue";
import {useAccountStore} from "@/stores/account.js";
import {AppConstant, CommonText} from "@/supports/app.constant";
import {ref, onMounted, computed, watch} from "vue";
import LabelPriority from "@/components/labels/label-priority/LabelPriority.vue";
import LabelStatus from "@/components/labels/label-status/LabelStatus.vue";
import IconEye from "@/components/icons/IconEye.vue";
import IconEdit from "@/components/icons/IconEdit.vue";
import IconTrash from "@/components/icons/IconTrash.vue";
import ButtonAddComponent from "@/components/buttons/button-add/ButtonAddComponent.vue";
import {useRouter} from "vue-router";
import PaginateComponent from "@/components/paginate/PaginateComponent.vue";
import InputCheckboxOne from "@/components/inputs/input-checkbox/normal/InputCheckboxNormal.vue";
import SelectCustom from "@/components/inputs/select/custom/SelectCustom.vue";
import {useSettingFormatFileStore} from "@/stores/settingFormatFile";
import CommonService from "@/services/common.service";

export default {
  name: 'SettingFormatFileComponent',
  components: {
    SelectCustom,
    InputCheckboxOne,
    PaginateComponent,
    ButtonAddComponent,
    IconTrash,
    IconEdit,
    IconEye,
    LabelStatus,
    LabelPriority, ButtonSearchComponent, SelectNormal, InputTextNormal, BreadcrumbComponent, IconHome},
  setup() {
    const dataHeaderTable =  ref({
      exportName: {
        label: 'Tên cài đặt',
        order: 2,
        width: '20%',
      },
      tableName: {
        label: 'Nơi sử dụng',
        order: 3,
        width: '8%',
      },
      type: {
        label: 'Kiểu file',
        order: 4,
        width: '8%',
      },
      description: {
        label: 'Mô tả',
        order: 5,
        width: '10%',
      },
      status: {
        label: 'Trạng thái',
        order: 6,
        width: '10%',
      },
    })
    const dataSearch = ref({
      table_use: {
        id: 'table_use',
        label: 'Nơi sử dụng',
        placeholder: 'Nơi sử dụng',
        value: '',
        required: false
      },
      name: {
        id: 'name',
        label: 'Tên cài đặt',
        placeholder: 'Tên cài đặt',
        value: '',
        required: false
      },
      type: {
        id: 'type',
        label: 'Kiểu file',
        placeholder: 'Kiểu file',
        value: '',
        required: false,
        options: [
          {
            name: 'Excel (.xlsx, .xls)',
            value: '1'
          },
          {
            name: 'CSV (.csv)',
            value: '2'
          },
        ]
      },
    })
    const labelButtonSearch = ref('Tìm kiếm')
    const labelButtonCreate = ref('Tạo cài đặt')
    const urlOrigin = ref('/setting/format-file')
    const selectAction = ref(CommonService.showDropdownAction(AppConstant.DROPDOWN_ACTION_FORMAT_FILE))
    const checkAll = ref(false)
    const checkItems = ref({})
    const listItemSelected = ref([])

    const settingFormatFileStore = useSettingFormatFileStore()
    const accountStore = useAccountStore()
    const router = useRouter()

    onMounted(() => {
      getListSettingExport(router.currentRoute.value.query.page ?? 1);
    });

    const listSettingFile = computed(() => {
      return settingFormatFileStore.settingFormat;
    });
    const paginate = computed(() => {
      return settingFormatFileStore.paginate;
    });

    watch(() => settingFormatFileStore.settingFormat, (newSettingFormatFiles) => {
      newSettingFormatFiles.forEach((item) => {
        if(checkItems.value[item.id] === undefined) {
          checkItems.value[item.id] = false
        }
      })
    });

    function searchSettings() {
      getListSettingExport(1);
    }
    function onChange(value, name) {
      dataSearch.value[name].value = value;
    }

    function getListSettingExport(page) {
      const params = {
        id: accountStore.account.company.id,
        table_use: dataSearch.value.table_use.value,
        name: dataSearch.value.name.value,
        page: page,
      }
      const url = AppConstant.URL_API_LOCAL + 'api/format-file/list';
      settingFormatFileStore.getListSettingFormatFile(url, params);
    }

    function redirectToCreate() {
      router.push('/setting/format-file/create')
    }

    function onChangeSelectAll(value) {
      checkAll.value = value
      for (const key in checkItems.value) {
        checkItems.value[key] = value
      }
      if(!value) {
        listItemSelected.value = []
      }else {
        listSettingFile.value.forEach((item) => {
          if(listItemSelected.value.indexOf(item.id) === -1) {
            listItemSelected.value.push(item.id)
          }
        })
      }
    }

    function onChangeSelectItem(value, name) {
      checkItems.value[name] = value
      let counterChecked = 0
      listSettingFile.value.forEach((item) => {
        if(checkItems.value[item.id]) {
          counterChecked++
        }
        if(value && listItemSelected.value.indexOf(item.id) === -1 && parseInt(name) === parseInt(item.id)) {
          listItemSelected.value.push(item.id)
        }else if (!value && listItemSelected.value[item.id]) {
          listItemSelected.value.splice(listItemSelected.value.indexOf(item.id), 1);
        }
      })
      checkAll.value = false
      if(counterChecked === listSettingFile.value.length) {
        checkAll.value = true
      }
    }

    function actionSelect(key) {
      if(listItemSelected.value.length === 0) {
        CommonService.showAlertPopup({
          title: 'Vui lòng chọn dữ liệu để thực hiện!',
          icon: "warning",
          showConfirmButton: false,
          timer: 1500,
          width: '800px'
        });
      }else {
        switch (parseInt(key)) {
          case AppConstant.ACTION_ENABLE_FORMAT_FILE:
            enableFormatFile();
            break;
          case AppConstant.ACTION_DOWNLOAD_FORMAT_FILE:
            downloadFormatFile();
            break;
        }
      }
    }

    async function enableFormatFile() {
      const params = {
        company_id: accountStore.account.company.id,
        format_file_ids: listItemSelected.value,
      }
      const url = AppConstant.URL_API_LOCAL + 'api/format-file/enable';
      const setting = await settingFormatFileStore.enableFormatFile(url, params);
      await CommonService.showAlertPopup({
        title: setting?.message,
        icon: setting?.status,
        showConfirmButton: false,
        timer: 2000,
        width: '800px'
      });

      await router.go();
    }

    async function downloadFormatFile() {
      if(listItemSelected.value.length > 1) {
        await CommonService.showAlertPopup({
          title: 'Vui lòng chọn một dữ liệu để thực hiện!',
          icon: "warning",
          showConfirmButton: false,
          timer: 1500,
          width: '800px'
        });
      }
      const itemSelected = listSettingFile.value.find((item) => item.id === listItemSelected.value[0])
      if(parseInt(itemSelected.status) === 2) {
        const params = {
          company_id: accountStore.account.company.id,
          format_file_id: listItemSelected.value[0],
        }
        const url = AppConstant.URL_API_LOCAL + 'api/format-file/download';
        const res = await settingFormatFileStore.downloadFormatFile(url, params);
        await CommonService.showAlertPopup({
          title: 'Tải file đã hoàn tất',
          icon: 'success',
          showConfirmButton: false,
          timer: 2000,
          width: '800px'
        });

        const settingFileSelected = listSettingFile.value.find((setting) => setting.id === listItemSelected.value[0])
        const blob = window.URL.createObjectURL(
            new Blob([res.data])
        );
        const link = document.createElement("a");
        link.href = blob;
        link.setAttribute("download", settingFileSelected.name + "." + CommonService.compareTypeFileLabel(settingFileSelected.type));
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blob);
        listItemSelected.value = [];
        checkItems.value = {}
        checkAll.value = false;
      }
    }

    function emitPage(page) {
      getListSettingExport(page);
    }

    function showSettingFile(settingId) {
      router.push('/setting/format-file/detail/' + settingId)
    }

    return {
      dataHeaderTable,
      labelButtonSearch,
      labelButtonCreate,
      dataSearch,
      listSettingFile,
      paginate,
      selectAction,
      checkAll,
      checkItems,
      urlOrigin,
      onChange,
      searchSettings,
      redirectToCreate,
      actionSelect,
      onChangeSelectAll,
      onChangeSelectItem,
      emitPage,
      showSettingFile,
      CommonText,
      CommonService
    }
  },
}
</script>
<style lang="scss">
.dashboard-page {
  margin-top: 80px;
  margin-left: 80px;
  height: 100%;
  .title-page {
    padding: 15px 30px;
    background-color: #fff;
  }
  .container-fluid {
    padding-top: 30px;
    .card {
      margin-bottom: 30px;
      letter-spacing: .5px;
      box-shadow: 0 9px 20px rgba(46,35,94,.07);
      .card-body {
        padding: 30px;
        border-radius: 15px;
        background-color: #ffffff;
        .btn-invite-partner {
          width: 150px;
          margin-top: 50px;
        }
        .list-partners-component {
          margin-top: 30px;
          .label_priority {
            padding: 5px;
            border: 1px solid #f73164;
            border-radius: 5px;
            max-width: 120px;
            width: 120px;
            display: flex;
            align-content: center;
            justify-content: center;
            color: #ffffff;
          }
          td.action {
            display: flex;
            justify-content: center;
            gap: 20px;
            .item-action {
              width: 20px;
              cursor: pointer;
            }
          }
          td.file-name {
            max-width: 500px;
            p {
              overflow-y: hidden;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              line-clamp: 1;
              -webkit-box-orient: vertical;
              margin: 0;
              text-decoration: underline;
              cursor: pointer;
            }
          }
        }

      }
    }
  }
}
</style>
